(() => {
  const key = 'freewink-reading-assistance';
  const root = document.documentElement;
  const fontClasses = ['freewink-a11y-font-small', 'freewink-a11y-font-large', 'freewink-a11y-font-xlarge'];
  const toggleClasses = { contrast: 'freewink-a11y-contrast', spacing: 'freewink-a11y-spacing', links: 'freewink-a11y-links', motion: 'freewink-a11y-motion' };

  const read = () => { try { return JSON.parse(localStorage.getItem(key)) || { font: 0 }; } catch (_) { return { font: 0 }; } };
  let state = read();
  const save = () => { try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {} };
  const apply = (panel) => {
    fontClasses.forEach((name) => root.classList.remove(name));
    if (state.font === -1) root.classList.add(fontClasses[0]);
    if (state.font === 1) root.classList.add(fontClasses[1]);
    if (state.font === 2) root.classList.add(fontClasses[2]);
    Object.entries(toggleClasses).forEach(([name, className]) => {
      root.classList.toggle(className, Boolean(state[name]));
      const control = panel.querySelector(`[data-a11y-toggle="${name}"]`);
      if (control) {
        control.setAttribute('aria-pressed', state[name] ? 'true' : 'false');
        control.lastElementChild.textContent = state[name] ? '●' : '○';
      }
    });
  };
  const init = () => document.querySelectorAll('[data-freewink-a11y]').forEach((widget) => {
    if (widget.dataset.ready) return;
    const trigger = widget.querySelector('.freewink-a11y__trigger');
    const panel = widget.querySelector('.freewink-a11y__panel');
    const close = widget.querySelector('.freewink-a11y__close');
    const open = (openPanel) => { panel.hidden = !openPanel; trigger.setAttribute('aria-expanded', openPanel ? 'true' : 'false'); if (openPanel) panel.querySelector('button')?.focus(); };
    trigger.addEventListener('click', () => open(panel.hidden));
    close.addEventListener('click', () => { open(false); trigger.focus(); });
    widget.addEventListener('click', (event) => {
      const action = event.target.closest('[data-a11y-action]')?.dataset.a11yAction;
      const toggle = event.target.closest('[data-a11y-toggle]')?.dataset.a11yToggle;
      if (action === 'font-down') state.font = Math.max(-1, (state.font || 0) - 1);
      if (action === 'font-up') state.font = Math.min(2, (state.font || 0) + 1);
      if (action === 'font-reset') state.font = 0;
      if (action === 'reset-all') state = { font: 0 };
      if (toggle) state[toggle] = !state[toggle];
      if (action || toggle) { save(); apply(panel); }
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !panel.hidden) { open(false); trigger.focus(); } });
    apply(panel);
    widget.dataset.ready = 'true';
  });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
